import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "@/context/ContentContext";
import { Layout } from "@/components/Layout";
import { api } from "@/lib/api";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Partnership from "@/pages/Partnership";
import Contact from "@/pages/Contact";
import { Privacy, Cookie } from "@/pages/Legal";
import References from "@/pages/References";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace("#", "")).get("session_id");
    const run = async () => {
      try {
        await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
      } catch (e) {
        console.error("auth failed", e);
      }
      window.history.replaceState(null, "", "/admin");
      navigate("/admin", { replace: true });
    };
    run();
  }, [location.hash, navigate]);

  return <div className="min-h-screen flex items-center justify-center text-gray-500">Logger ind...</div>;
};

const withLayout = (el) => <Layout>{el}</Layout>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={withLayout(<Home />)} />
        <Route path="/ydelser" element={withLayout(<Services />)} />
        <Route path="/om-os" element={withLayout(<About />)} />
        <Route path="/samarbejde" element={withLayout(<Partnership />)} />
        <Route path="/referencer" element={withLayout(<References />)} />
        <Route path="/kontakt" element={withLayout(<Contact />)} />
        <Route path="/privatlivspolitik" element={withLayout(<Privacy />)} />
        <Route path="/cookiepolitik" element={withLayout(<Cookie />)} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={withLayout(<NotFound />)} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </ContentProvider>
  );
}

export default App;
